import { NgModule } from '@angular/core'
import { BookingMultiDayComponent } from './booking-multi-day.component'
import { DatesGroupsComponent } from './step01-dates-groups/dates-groups.component'
import { Step02RoomsFormComponent } from './step02-rooms-form/step02-rooms-form.component'
import { Step03FacilitiesFormComponent } from './step03-facilities-form/step03-facilities-form.component'
import { Step04CateringFormComponent } from './step04-catering-form/step04-catering-form.component'
import { ListDateLiBtnComponent } from './compnents/list-date-li-btn/list-date-li-btn.component'
import { AddDateBtnComponent } from './compnents/add-date-btn/add-date-btn.component'
import { GetDependantProductsPipe } from './step03-facilities-form/get-dependant-products.pipe'
import { IsAnyProductSelectedPipe } from './is-any-product-selected.pipe'
import { GetSelectedDateFormGroupPipe } from './step03-facilities-form/get-selected-date-form-group.pipe'
import { GetSelectedDateProductFormGroupPipe } from './step03-facilities-form/get-selected-date-product-form-group.pipe'
import { SharedModule } from '../../../shared/shared.module'
import { CommonModule } from '@angular/common'
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker'
import { NzSelectModule } from 'ng-zorro-antd/select'
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker'
import { NzInputNumberModule } from 'ng-zorro-antd/input-number'
import { NzGridModule } from 'ng-zorro-antd/grid'
import { BookingMultiDayRoutingModule } from './booking-multi-day-routing.module'
import { BookingMultiDayModalComponent } from './booking-multi-day-modal/booking-multi-day-modal.component'
import { IsDependantProductSelectedPipe } from './step03-facilities-form/is-dependant-product-selected.pipe'
import { getDisabledHoursPipe } from './step03-facilities-form/get-disabled-hours.pipe'
import { ProductModule } from '../../product/product.module'
import { IsBookedDuringStayPipe } from './step03-facilities-form/is-booked-during-stay.pipe'

@NgModule({
  declarations: [
    BookingMultiDayComponent,
    DatesGroupsComponent,
    Step02RoomsFormComponent,
    Step03FacilitiesFormComponent,
    Step04CateringFormComponent,
    ListDateLiBtnComponent,
    AddDateBtnComponent,
    GetDependantProductsPipe,
    IsAnyProductSelectedPipe,
    GetSelectedDateFormGroupPipe,
    GetSelectedDateProductFormGroupPipe,
    BookingMultiDayModalComponent,
    IsDependantProductSelectedPipe,
    IsBookedDuringStayPipe,
    getDisabledHoursPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    BookingMultiDayRoutingModule,
    NzDatePickerModule,
    NzSelectModule,
    NzTimePickerModule,
    NzInputNumberModule,
    NzGridModule,
    ProductModule
  ],
  exports: [
    BookingMultiDayComponent,
    DatesGroupsComponent,
    Step02RoomsFormComponent,
    Step03FacilitiesFormComponent,
    Step04CateringFormComponent,
    ListDateLiBtnComponent,
    AddDateBtnComponent,
    GetDependantProductsPipe,
    IsAnyProductSelectedPipe,
    GetSelectedDateFormGroupPipe,
    GetSelectedDateProductFormGroupPipe,
    BookingMultiDayModalComponent
  ],
  providers: []
})
export class BookingMultiDayModule {}
